import { useEffect, useState } from "react";
import { User } from "firebase/auth";
import { fetchBillingData } from "@/lib/api";
import { BillingData } from "@/types/auth";

export function useBillingMinimal(user: User | null) {
    const [billingData, setBillingData] = useState<BillingData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            if (!user) return;
            try {
                setLoading(true);
                setError(null);
                const data = await fetchBillingData();
                setBillingData(data);
            } catch (err) {
                const errorMessage = err instanceof Error ? err.message : "Failed to fetch billing data";
                setError(errorMessage);
                console.error("Billing data fetch error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [user]);

    return { billingData, loading, error };
}